import { DetailsListLayoutMode, IColumn, SelectionMode, ShimmeredDetailsList, Stack, Text } from "@fluentui/react";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { AccessTokens } from "../../../services/API/BaseService";
import { FailedOperationDto, getFailedOperations } from "../../../services/API/StatisticsService";

const columns: IColumn[] = [
  {
    key: "operation_Name",
    name: "Operation Name",
    fieldName: "operation_Name",
    minWidth: 200,
    isResizable: true,
  },
  {
    key: "failedCount",
    name: "Failed Count",
    fieldName: "failedCount",
    minWidth: 100,
    maxWidth: 100,
    isResizable: false,
  },
  {
    key: "impactedUsers",
    name: "Impacted Users",
    fieldName: "impactedUsers",
    minWidth: 100,
    maxWidth: 100,
    isResizable: false,
  },
];

type CardProps = {
  accessTokens: AccessTokens;
};

export const FailedOperationsCard: React.FC<CardProps> = ({ accessTokens }: CardProps) => {
  const [failedOperations, setFailedOperations] = useState<FailedOperationDto[]>();

  useEffect(() => {
    getFailedOperations(accessTokens).then(setFailedOperations);
  }, [setFailedOperations]);

  return (
    <Stack className="dashboardCardWrapper failedOperationsCard">
      <Text variant="large">Failed Operations</Text>
      <Stack className="dashboardCardListWrapper">
        <ShimmeredDetailsList
          items={failedOperations || []}
          columns={columns}
          layoutMode={DetailsListLayoutMode.justified}
          selectionMode={SelectionMode.none}
          enableShimmer={!failedOperations}
          shimmerLines={5}
        />
      </Stack>
    </Stack>
  );
};
